module.exports = __webpack_public_path__ + "static/img/062.aeb7f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/062.png
// module id = OiyX
// module chunks = 0